import { FC } from 'react';
import { addSpaceNumber } from 'utils/addSpaceNumber';
import styles from './FormatAmount.module.scss';

interface FormatAmountTypes {
  amount: string;
  compact?: boolean;
  stylePadding?: boolean;
}

export const FormatAmount: FC<FormatAmountTypes> = ({
  amount,
  compact = false,
  stylePadding,
}) => {
  const formatted = addSpaceNumber(amount);

  const splitted = formatted.split(',');

  const [head, decimal] = splitted;

  const compactPadding = compact ? { padding: stylePadding ? '12px 8px' : 0 } : undefined;

  if (amount === null) {
    return (
      <div className={styles.item} style={compactPadding}>
        -<div className={styles.item_decimal}></div>
      </div>
    );
  }

  if (decimal) {
    return (
      <div className={styles.item} style={compactPadding}>
        {head}
        <div className={styles.item_decimal}>,{decimal}</div>
      </div>
    );
  }

  return (
    <div className={styles.item} style={compactPadding}>
      {head}
      <div className={styles.item_decimal}>,00</div>
    </div>
  );
};
